<dms-table [tableConfig]="tableConfig" [tableData]="tableData" (selectedRow)="rowSelected($event)" tableType="group" #groupTable>
</dms-table>